import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import { useTranslation } from "react-i18next";

import { useDeleteSubjectSubjectsIdDeleteMutation } from "api";
import { useNavigate } from "hooks/useNavigate";

type DeleteSubjectDialogProps = {
  subjectId: string;
  zoneId: string;
};

export function DeleteSubjectDialog({
  subjectId,
  zoneId,
}: DeleteSubjectDialogProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [showDelete, setShowDelete] = useState(false);

  const [deleteSubject, { isLoading }] =
    useDeleteSubjectSubjectsIdDeleteMutation();

  const handleDeleteSubject = async () => {
    try {
      await deleteSubject({ id: subjectId });

      navigate(`/administration/zones/${zoneId}/subjects`, { replace: true });
    } catch (error) {
      console.error("Failed to delete subject:", error);
    }
  };

  return (
    <Box alignSelf={"flex-end"}>
      <Button color={"error"} onClick={() => setShowDelete(true)}>
        {t("Delete subject")}
      </Button>
      <Dialog open={showDelete} onClose={() => setShowDelete(false)}>
        <DialogTitle>{t("Delete subject")}</DialogTitle>
        <DialogContent dividers>
          {t(
            "deleting_this_subject_will_also_delete_the_sleep_data_associated_with_the_subject",
          )}
        </DialogContent>
        <DialogActions>
          <Button
            color={"error"}
            onClick={handleDeleteSubject}
            loading={isLoading}
          >
            {t("Delete")}
          </Button>
          <Button variant={"text"} onClick={() => setShowDelete(false)}>
            {t("Cancel")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
